import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicOrganisation } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getOrganisation = async (id: string): Promise<PublicOrganisation> => {
  // yes, you need to pass the id in the url before the resource name
  const response = await axiosClient.get(`${id}/organisations/`);
  return response.data;
};

export const getOrganisationQueryKey = (id: string) => ["organisation", id];

export function useGetOrganisation(
  { id }: { id: string },
  queryOptions?: Partial<UseQueryOptions<PublicOrganisation, HttpError>>,
) {
  return useQuery({
    queryKey: getOrganisationQueryKey(id),
    queryFn: () => getOrganisation(id),
    ...queryOptions,
  });
}
